import { ComponentProps, forwardRef } from 'react';

import { mergeClassNames } from '@lib/utils';

export const Skeleton = forwardRef<HTMLDivElement, ComponentProps<'div'>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={mergeClassNames(
        'animate-pulse rounded-md bg-slate-200',
        className,
      )}
      {...props}
    />
  ),
);
Skeleton.displayName = 'Skeleton';
